import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInterceptorInstance from './axiosInterceptorInstance';

export const getBankList = createAsyncThunk('bank/getBankList', async () => {
  try {
    const relativeUrl = 'Bank/GetBankList/';
    const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
    const response = await axiosInterceptorInstance.get(apiUrl);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getNationalityList = createAsyncThunk(
  'nationality/getNationalityList',
  async (language: string) => {
    try {
      const relativeUrl = 'Nationality/GetNationalityList?language=' + language;
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getOccupationList = createAsyncThunk(
  'occupation/getOccupationList',
  async () => {
    try {
      const relativeUrl = 'Occupation/GetOccupationList/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getIndustryList = createAsyncThunk(
  'industry/getList',
  async () => {
    try {
      const relativeUrl = 'Industry/GetList/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getSourceOfFundList = createAsyncThunk(
  'sourceOfFund/getSourceOfFundList',
  async () => {
    try {
      const relativeUrl = 'SourceOfFund/GetSourceOfFundList/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const getCountryOfResidence = createAsyncThunk(
  'countryOfResidence/getList',
  async () => {
    try {
      const relativeUrl = 'ResidenceCountry/GetList/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);
